import { Component } from '@angular/core';

@Component({
	selector: 'layout-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.scss'],
})
export class LayoutMainComponent {
}
